import axios from "axios";
import { API_CONFIG } from "../utils/constants";
import { clearSession, refreshSession } from "./session";

const baseURL = `${API_CONFIG.BASE_URL}/api`;

const instance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

let failing = false;

function failAuth(staleRefresh, notice) {
  if (staleRefresh && localStorage.getItem("refreshToken") && localStorage.getItem("refreshToken") !== staleRefresh) {
    window.dispatchEvent(new CustomEvent("trazia-token"));
    return;
  }
  if (failing) return;
  failing = true;
  if (notice) sessionStorage.setItem("trazia-session-notice", notice);
  clearSession();
  if (!window.location.pathname.startsWith("/login")) {
    window.location.assign("/login");
  }
  setTimeout(() => {
    failing = false;
  }, 1500);
}

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const isAbsoluteUrl = /^https?:\/\//i.test(config.url);

    if (token && !isAbsoluteUrl) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const original = error.config || {};
    const url = String(original.url || "");
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/refresh");

    if (status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        const token = await refreshSession();
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${token}`;
        return instance(original);
      } catch (err) {
        const message = err?.response?.data?.message;
        const notice =
          typeof message === "string" && message.includes("otro dispositivo") ? message : "";
        failAuth(err?.staleRefresh, notice);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
